import axios from 'axios';
import AppState from './../appState';
import BrandConfig from './../brandConfig';
import {generateUUID} from './../common/utils.js'


const USE_MOCK_DATA = false;

const PROXY_API_URL = process.env.PROXY_API_URL || 'https://9yzvi3t145.execute-api.ca-central-1.amazonaws.com/production-kds/kds';
const VM_API_URL = process.env.VM_API_URL || 'https://aws-api.harveys.ca/CaraAPI/servlet/VESBCmdServlet';
const JARVIS_API_URL = 'https://jarvis-api.recp.ca'

const KDS_SERVICE_PREFIX = (process.env.KDS_SERVICE_PREFIX || process.env.KDS_SERVICE_PREFIX === '')
                         ? process.env.KDS_SERVICE_PREFIX
                         : 'gkds_';   // prefix for all GKDS web services, legacy services did not have this

// local endpoint override lookup list based on storeNumber
const ENPOINT_LOOKUP = {
//  "3033": "http://172.31.90.10:90",
  "6666": "http://172.31.90.7:90"
};



// axios used for proxy and VM api calls
axios.defaults.baseURL = PROXY_API_URL;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';


// global promises store, needed for native calls
window.promises = {};
// global native calls response invoker function
window.resolveRequest = function(promiseId, data, error, status) {
  console.log('response:' + promiseId + ' data:' + data + ' error:' + JSON.stringify(error) + ' status:' + status);
  if (error) {
    promises[promiseId].resolve({error: error});
  } else {
    promises[promiseId].resolve({data: data});
  }

  delete promises[promiseId];
}

// external functions and properties
////////////////////////////////////
export default {
  mainAPIServer: PROXY_API_URL,
  endPoint: PROXY_API_URL,
  useOverride: false,
  useProxyApi: false,  // flag for using the old PAT proxy api
  storeSelected: false,
  language_flag: null,
  language: 'EN',
  vmSessionID: null,
  sessionRetryCount: 0,
  station: 'kds',
  binType: 'all',
  brand: BrandConfig.brandDefault,
  kdsDetailView: true,
  useMockData: USE_MOCK_DATA,

  // set intial apps state to defaults
  appState: AppState.defaultAppState(),

  // API functions
  //////////////////////
  apiObject (method, apiParameters)  {
    // build and return api object to send for http request to axios, mixin and format apiParameters
    ///////////////////////////////////
    method = method || "post";
    apiParameters = apiParameters || {};

    var pathSuffix = '';
    var queryString = '';

    if (apiParameters.service) {
      if (this.useProxyApi) {
        // put service into querystring instead of path
        queryString = '?service=' + KDS_SERVICE_PREFIX + apiParameters.service;
      } else {
        // put service into path
        pathSuffix = KDS_SERVICE_PREFIX + apiParameters.service;
      }
    }

    if (typeof apiParameters.queryString === 'object') {
      // go through all parameters in querystring object and build string
      for (var q in apiParameters.queryString) {
        if (queryString) {
          queryString += '&' + q + '=' + apiParameters.queryString[q];
        } else {
          queryString = '?' + q + '=' + apiParameters.queryString[q];
        }
      }
    }

    let objApiCall = {};
    let payloadSuffix = '';
    if (apiParameters.baseURL == 'use_native') {
      // native api package
      objApiCall = {
        method: method,
        path: pathSuffix + queryString
      }
    } else if (apiParameters.baseURL && apiParameters.path) {
      // VisionMax of Jarvis api package
      objApiCall = {
        method: method,
        baseURL: apiParameters.baseURL,
        url: apiParameters.baseURL + apiParameters.path + queryString
      }
      payloadSuffix = 'reqJSON=';
    } else {
      // proxy api package
      objApiCall = {
        method: method,
        url: this.endPoint + '/' + pathSuffix + queryString
      }
    }

    if (apiParameters.payload) {
      if (typeof apiParameters.payload === "object") {
        objApiCall.data = payloadSuffix + JSON.stringify(apiParameters.payload);
      } else {
        objApiCall.data = payloadSuffix + apiParameters.payload;
      }
      
    }

    if (apiParameters.withCredentials) {
      // set sticky cookie support
      objApiCall.withCredentials = true;
    }

    return objApiCall
  },

  httpGet (apiParameters, callback) {
    this.httpCall('get', apiParameters, callback);
  },

  httpPost (apiParameters, callback) {
    this.httpCall('post', apiParameters, callback);
  },

  httpCall(method, apiParameters, callback) {
    let apiObject = {};
    if (USE_MOCK_DATA) {
      let variant = '';
      if (apiParameters.service == 'getECommItems') {
        let orderId = apiParameters.queryString['check_num'];
        // mix up item calls
        if (orderId % 2 == 0) {
          variant = '1';
        } else {
          variant = '2';
        }
      }
      let path = 'mock_data/' + apiParameters.service + variant + '.json';
      this.readFromStatic(path, (data) => {
        let response = {
          status: 200,
          data: data
        };
        callback(response);

      });
    } else if (this.useOverride) {
      apiObject = this.apiObject(method, apiParameters);
      this.directApiCall(apiObject, callback);
    } else if (this.useProxyApi) {
      apiObject = this.apiObject(method, apiParameters);
      this.proxyApiCall(apiObject, callback);
    } else {
      apiParameters.baseURL = 'use_native';
      apiObject = this.apiObject(method, apiParameters);
      this.nativeCall(apiObject, callback);
    }
  },

  directApiCall(apiObject, callback) {
    axios(apiObject)
    .then(response => {
		  if (response.status !== 200) {  
        console.log('Error - Status Code: ' + response.status);  
        return;  
		  }

      if (typeof callback === "function") {
        callback(response);
      }
	  })  
    .catch(error => {
      console.log(error);

      if (typeof callback === "function") {
        callback({errorMsg: error});
      }      
    });
  },

  proxyApiCall(apiObject, callback) {
    // clear and reset get headers
    axios.defaults.headers.get = {};
    axios.defaults.headers.get['x-api-key'] = 'vTr6BdBfqa7DtBj3WRzyQ57r0lFAXRD9a1expX7v';

    axios(apiObject)
    .then(response => {
		  if (response.status !== 200) {  
        console.log('Error - Status Code: ' + response.status);  
        return;  
		  }

      if (typeof callback === "function") {
        callback(response);
      }
	  })  
    .catch(error => {
      console.log(error);

      if (typeof callback === "function") {
        callback({errorMsg: error});
      }      
    });
  },

  async nativeCall(apiObject, callback) {
    // build request in format expected
    let request = {
      id: generateUUID(),
      method: apiObject.method.toUpperCase(),
      url: apiObject.url || '',
      path: apiObject.path || ''
    }

    if (apiObject.data) {
      request.body = apiObject.data;
    }

    let response = {
      data: null,
      status: 200
    }

    let nativeResponse = null;
    if (request.path) {
      nativeResponse = await this.nativeServerCall(request);
    } else {
      nativeResponse = await this.nativeProxyCall(request);
    }

    if (!nativeResponse || nativeResponse.error) {
      response.nativeError = 'connection_error';
    } else {
      try {
        response.data = JSON.parse(nativeResponse.data);
      } catch (e) {
        response.nativeError = 'no_data';
      }
    } 

    if (typeof callback === "function") {
      callback(response);
    }
  },

  nativeProxyCall(request) {
    let promise = new Promise(function (resolve, reject) {
        window.promises[request.id] = {resolve, reject};
        window.webkit.messageHandlers.network.postMessage(request);
    });

    return promise;
  },

  nativeServerCall(request) {
    let promise = new Promise(function (resolve, reject) {
        window.promises[request.id] = {resolve, reject};
        window.webkit.messageHandlers.storeServer.postMessage(request);
    });

    return promise;
  },

  // Endpoint reset functions
  //////////////////////
  initFromConfig(config) {
    if (!config) return false;

    this.setStore(config.storeId);
    this.setStation(config);
    this.setLanguage(config);
    this.setProxy(config);

    return true;
  },


  setStore (storeNumber) {
    if (!storeNumber) return false;
    
    this.storeNumber = parseInt(storeNumber);
    if (this.storeNumber && this.storeNumber>0) {
      this.storeSelected = true;

      // setup config based on store number / brand 
      this.brand = BrandConfig.getBrandFromStoreNumber(storeNumber);
      this.appState.orderChannelExclusionList = BrandConfig.orderChannelExclusionList(this.brand);
      this.appState.orderPanelDisplay = BrandConfig.orderPanelDisplay(this.brand);
      this.appState.showReadyOverrideList = BrandConfig.showReadyOverrideList();
      
    } else {
      this.storeSelected = false;
    }

    return this.storeSelected;
  },

  setStation (config) {
    // set the station type:  KDS or Bin Management
    if (config.station === 'bin') {
      this.station = 'bin';
      if (config.binType === 'grill' || config.binType === 'fry') {
        this.binType = config.binType;
      } else {
        this.binType = 'all';
      }
    } else {
      this.station = 'kds';
    }
  },

  setLanguage (config) {
    if (config.language) {
      console.log('Setting language from system: ' + config.language);

      this.language_flag = 'system';
      if (config.language.indexOf('fr') >= 0) {
        this.language = 'FR'
      } else {
        this.language = 'EN'
      }            
    }
  },

  setProxy (config) {
    if (config.useProxy) {
      this.useProxyApi = true;
    } else {
      this.buildEndpoint(config.storeId);
    }
  },

  setEndpoint (url) {
    this.endPoint = url;
    axios.defaults.baseURL = url;
  },

  buildEndpoint () {
    console.log('building endpoint: ' + this.storeNumber);
    if (this.storeNumber) {
      this.useProxyApi = false;
      if (this.checkOverride(this.storeNumber)) {
        // use endpoint override
        this.setEndpoint(this.checkOverride(this.storeNumber));
        this.useOverride = true;
      } else {
        // use generated endpoint based on store number
        this.setEndpoint('http://h' + this.storeNumber + 'server:90');
      }
    }
  },

  checkOverride(storeNumber) {
    if (ENPOINT_LOOKUP && ENPOINT_LOOKUP[''+storeNumber]) {
      return ENPOINT_LOOKUP[''+storeNumber];
    }

    return null;
  },

  // VisionMax api calls for Push Notification
  ////////////////////////////////////////////
  vmOpenSession (callback) {
    console.log('Opening VM session.');
    
    var apiParameters = {
        baseURL: VM_API_URL,
//        withCredentials: true,
        path: '?application=VECOMV1&service=AuthenticationService&command=createSession',
        payload:  {request: {
                        requestHeader: {
                          caller: 'KDS'
                        },
                        requestContent: {
                          '@class': 'createSessionRqstModel',
                          lang: 'EN',
                          version: '1.0.1',
                          appType: 'web'
                        }
                      }
                    }
    };

    var apiObject = this.apiObject('post', apiParameters);

    axios(apiObject)
    .then(response => {
      var success = false;
      
		  if (response.status !== 200) {
        console.log('Error - Status Code: ' + response.status);  
		  } else {
        if (this.apiHelper.checkApiCallSuccess(response)) {
          var sessionId = this.apiHelper.getApiResponseData(response).veSessionID; 
          if (typeof sessionId === 'number') {
            this.vmSessionID = sessionId;
            success = true;
          }
        }
      }

      if (typeof callback === 'function') callback(success);
	  })
    .catch(error => {
      console.log(error);
      if (typeof callback === 'function') callback(false);
    });

  },

  vmPushNotification(vpTicketNumber, callback) {
    console.log('VM Push Notification.');

    if (typeof this.vmSessionID !== 'number' || !this.vmSessionID) {
      this.vmPushNotificationSessionCheck(vpTicketNumber, callback);
      return;
    }

    var apiParameters = {
        baseURL: VM_API_URL,
//        withCredentials: true,
        path: '?application=VECOMV1&service=OrderService&command=updateOrderSubStatus',
        payload:  {request: {
                        requestHeader: {
                          caller: 'KDS',
                          sessionId:  this.vmSessionID
                        },
                        requestContent: {
                          '@class': 'UpdateOrderSubStatusRqstModel',
                          ticketNumber: vpTicketNumber,
                          orderSubStatus: "Dispatched"
                        }
                      }
                    }
    };

    var apiObject = this.apiObject('post', apiParameters);

    axios(apiObject)
    .then(response => {
      var success = false;
      
		  if (response.status !== 200) {
        console.log('Error - Status Code: ' + response.status);  
        if (typeof callback === 'function') callback(success);
		  } else {
        if (response.data.response.responseHeader.result == 'Success') {
          success = true;
          if (typeof callback === 'function') callback(success);
        } else {
          // check for invalid session and recover
          if (response.data && response.data.response && 
              response.data.response.responseHeader && 
              response.data.response.responseHeader.errCode == 'INVALID_SESSION_ID') 
          {
            this.vmPushNotificationSessionCheck(vpTicketNumber, callback);
          } else {
            if (typeof callback === 'function') callback(response);
          }
        }
      }
	  })
    .catch(error => {
      console.log(error);
      if (typeof callback === 'function') callback(response);
    });

  },

  vmPushNotificationSessionCheck(vpTicketNumber, callback) {
    this.sessionRetryCount ++;

    if (this.sessionRetryCount > 5) {
      // give up and reset after some attempts
      this.sessionRetryCount = 0;
      console.log('Failed to open VM session');
      if (typeof callback === 'function') callback(false);
    } else {
      if (this.vmSessionID) {
        setTimeout(()=>{
          this.vmPushNotification(vpTicketNumber, callback);
        }, 5000);
      } else {
        this.vmOpenSession(success => {
          if (success) {
            this.vmPushNotification(vpTicketNumber, callback);
          } else {
            // try again
            this.vmPushNotificationSessionCheck(vpTicketNumber, callback);
          }
        });
      }
    }
  },


  jarvisBinManagement(storeId, businessDate, callback) {
    console.log('Jarvis Bin Management call.');

    // clear and reset get headers
    axios.defaults.headers.get = {};
    axios.defaults.headers.get['authorization'] = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHAiOiJLRFMifQ.JGb6IC4HBb4u8OpE3h3MEwiwFtaN6Qglu8txs4yHO2k';

    var apiParameters = {
        baseURL: JARVIS_API_URL,
        path: '/kds/bin/store/' + storeId,
        queryString: {
          'businessDate': businessDate,
          'prepLocation': this.binType
        },
    };

    var apiObject = this.apiObject('get', apiParameters);

    axios(apiObject)
    .then(response => {
      var success = false;
      
		  if (response.status !== 200) {
        console.log('Error - Status Code: ' + response.status);  
        if (typeof callback === 'function') callback(success);
		  } else {
        if (response.data) {
          if (typeof callback === 'function') callback(response.data);
        } else {
        }
      }
	  })
    .catch(error => {
      console.log(error);
      if (typeof callback === 'function') callback(error);
    });

  },

  readFromStatic(path, callback) {
    let baseURL = location.protocol + '//' + location.hostname;
    if (location.port) baseURL += ':' + location.port;
  
    let objApiCall = {
      method: 'get',
      baseURL: baseURL,
      url: baseURL + '/static/' + path
    }
  
    axios(objApiCall)
    .then(response => {
      if (typeof callback === 'function') callback(response.data);
    })
    .catch(error => {
      if (typeof callback === 'function') callback(null)
    });
  },

  // State functions
  //////////////////////
  getState() {
    //var savedState = AppState.getLocalStorage();
    var savedState = AppState.getStateCookie();

    if (savedState) {
      this.appState = savedState;

      this.mainAPIServer = this.appState.mainAPIServer || PROXY_API_URL;
      this.endPoint = this.appState.endPoint || PROXY_API_URL;
      this.storeSelected = this.appState.storeSelected || false;
      this.storeNumber = this.appState.storeNumber;
      this.kdsDetailView = this.appState.kdsDetailView;
    }
  },

  saveState() {
    console.log ('state saved');
    this.appState.mainAPIServer = this.mainAPIServer;
    this.appState.endPoint = this.endPoint;
    this.appState.storeSelected = this.storeSelected;
    this.appState.storeNumber = this.storeNumber;
    this.appState.kdsDetailView = this.kdsDetailView;

    //AppState.setLocalStorage(this.appState);
    AppState.saveStateCookie(this.appState);
  },

  getStateObject(){
    console.log ('state loaded');    
    return this.appState;
  },

  apiHelper: {
      checkApiCallSuccess: function(response) {
        // Check api call success status based on VisionMax's expected results
        // returns true only if calls was successful and brought back approriate data
        if (!response) return false;
        if (!response.data) return false;
        if (!response.data.response) return false;
        if (!response.data.response.responseContent) return false;
        if (response.data.response.responseContent.status &&
            response.data.response.responseContent.status.toLowerCase() === "success") return true;
        if (response.data.response.responseContent.businessStatusModel &&
            response.data.response.responseContent.businessStatusModel.status &&
            response.data.response.responseContent.businessStatusModel.status.toLowerCase() === "success") return true;
        
        return false;
      },

      getApiResponseData: function(response) {
        // Return relevant data object, despite some variations in response from API
        // if anything is wrong it returns empty object
        if (!response) return {};
        if (!response.data) return {};
        if (!response.data.response) return {};
        if (!response.data.response.responseContent) return {};
        
        return response.data.response.responseContent;
      },


      getApiCallError: function(response) {
        // Check api response for any error that may have come back from the server
        // and return the error string
        var errMsg = response.data || response;

        if (!response) return errMsg;
        if (!response.data) return errMsg;
        if (!response.data.response) return errMsg;
        if (!response.data.response.responseContent) return errMsg;
        if (response.data.response.responseContent.businessStatusModel && 
            response.data.response.responseContent.businessStatusModel.screenMsg) {
              errMsg = response.data.response.responseContent.businessStatusModel.screenMsg;
        }
        if (response.data.response.responseContent.screenMsg) {
              errMsg = response.data.response.responseContent.screenMsg;
        }

        return errMsg;
      }
      
  }
}



// WEBPACK FOOTER //
// ./src/apiBridge/index.js